"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHasEnteredViewport = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Returns true when component enters viewport
 * @param ref reference to component
 */
var useHasEnteredViewport = function useHasEnteredViewport(ref) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasEntered = _useState2[0],
      setHasEntered = _useState2[1];

  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var rect = ref.current.getBoundingClientRect();

      if (rect.top <= window.innerHeight - rect.height) {
        setHasEntered(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.dispatchEvent(new Event("scroll"));
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return hasEntered;
};

exports.useHasEnteredViewport = useHasEnteredViewport;
//# sourceMappingURL=useHasEnteredViewPort.js.map